import AppCopy from "copy/AppCopy";

function CarRequestHeader() {
  const { dateText } = AppCopy.reportsPage;

  return (
    <div className={Classname.container}>
      <span className={Classname.carNo}>Customer</span>
      <span className={Classname.customer}>Phone</span>
      <span className={Classname.model}>Request type</span>
      <span className={Classname.model}>Description</span>
      <span className={Classname.date}>{dateText}</span>
    </div>
  );
}

export default CarRequestHeader;

const Classname = {
  container:
    "w-full border-b hidden sm:flex items-center justify-between text-sm text-secondaryText py-2",
  carNo: "w-1/6",
  customer: "w-1/6",
  model: "w-1/6 flex ",
  date: "w-1/6 flex",
  detail: "w-1/6",
};
